import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { page } from "@/lib/analytics";

/**
 * Records one page view per route change.
 *
 * PostHog’s autocapture only fires on a full document load, so in a SPA the
 * whole app registered as a single pageview and every funnel step after the
 * landing page was invisible.
 *
 * Keyed on pathname only: search params on the job search page change on every
 * keystroke, which would flood the stream with near-duplicate views.
 */
export default function PageViewTracker() {
  const { pathname } = useLocation();
  useEffect(() => { page(pathname); }, [pathname]);
  return null;
}
